<div>
	<p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" 
			  [style]="{'width': '1000px', 'height': '600px'}" [resizable]="false">

		<p-header>
			<span>Policy State Details - {{policyName}}</span>
		</p-header>

		<div>
			<p-table #dt class="snmpif-state-table" [value]="entries"
					 [resizableColumns]="true"
					 [scrollable]="true" scrollHeight="calc(406px)"
					 [customSort]="true" (sortFunction)="doCustomSort($event)">

				<ng-template pTemplate="header">
					<tr>
						<th pResizableColumn pSortableColumn="deviceName">
							Device
							<p-sortIcon field="deviceName"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="ipAddress">
							IP Address
							<p-sortIcon field="ipAddress"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="ifIndex">
							IF Index
							<p-sortIcon field="ifIndex"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="ifName">
							IF Name
							<p-sortIcon field="ifName"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="inOutMbps">
							In/Out MBPS
							<p-sortIcon field="inOutMbps"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="stateDetails">
							State Details
							<p-sortIcon field="stateDetails"></p-sortIcon>
						</th>
						<th pResizableColumn pSortableColumn="state">
							State
							<p-sortIcon field="state"></p-sortIcon>
						</th>
					</tr>

					<tr class="uv-table-filter">
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'deviceName', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'ipAddress', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'ifIndex', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'ifName', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'inOutMbps', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'stateDetails', 'contains')">
						</th>
						<th>
							<input pInputText type="text" style="width: 100%;"
								(input)="dt.filter($event.target.value, 'state', 'contains')">
						</th>
					</tr>		
				</ng-template>

				<ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
					<tr [pSelectableRow]="rowData">
						<td>
							<span class="uv-table-value">{{rowData['deviceName']}}</span>
						</td>
						<td>
							<span class="uv-table-value">{{rowData['ipAddress']}}</span>
						</td>
						<td>
							<span class="uv-table-value">{{rowData['ifIndex']}}</span>
						</td>
						<td>
							<span class="uv-table-value">{{rowData['ifName']}}</span>
						</td>
						<td>
							<span class="uv-table-value">{{rowData['inOutMbps']}}</span>
						</td>
						<td pTooltip="{{rowData['stateDetails']}}">
							<span class="uv-table-value">{{rowData['stateDetails']}}</span>
						</td>
						<td [className]="rowData['style']">
							<span class="uv-table-value">{{rowData['state']}}</span>
						</td>
					</tr>
				</ng-template>

			</p-table>

			<div style="margin-top: 3px;">
				<button type="button" (click)="refreshEntries()" pButton icon="fa fa-refresh" label="Refresh"></button>
			</div>
		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="onCloseClicked()" label="Close"></button>
		</p-footer>

	</p-dialog>
</div>